module.exports = __webpack_public_path__ + "img/bg-recipe.8b870174.jpg";